import { render } from "./Title.vue?vue&type=template&id=0a9b4098&scoped=true"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"

import "./Title.vue?vue&type=style&index=0&id=0a9b4098&scoped=true&lang=css"

import exportComponent from "D:\\Code_projects\\maria_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9b4098"]])

export default __exports__